import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { Card, CardBody } from "reactstrap";
import * as yup from "yup";
import * as XLSX from "xlsx";
import { getUserList } from "../../../redux/invoice/action";
import { exportAllReports, getAllReports } from "../../../redux/service/action";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { getMembershipList } from "../../../redux/membership/action";
import { utils, write } from "xlsx";
import { formatDate, formatDateInput } from "../../Common/Utils/dateUtils";
import TestingAccountFilter from "../../Common/TestingAccountFilter";
// import { saveAs } from "file-saver";
export const invoiceReportValidation = () =>
  yup.object({
    start_date: yup.date(),
    end_date: yup
      .date()
      .min(yup.ref("start_date"), "End date cannot be before start date"),
    user_id: yup.string(),
  });

const FreeTrailReport = () => {
  const dispatch = useDispatch();
  const [endDates, setEndDates] = useState("");
  const [loading, setLoading] = useState(false);
  const [startDates, setStartDates] = useState("");
  const [reportsData, setReportsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectStatus, setSlectStatus] = useState("");
  const [showFilter, setSHowFilter] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
    const [exportLoader, setExportLoader] = useState(false);
  const [selectedOptionsMember, setSelectedOptionsMember] = useState([]);
  const [theFilterInfo, setTheFilterInfo] = useState({
    user_id: "",
    start_date: "",
    end_date: "",
    status: "",
    testing_account_filter: "hide",
    type: "freetrail_report",
  });

  const [params, setParams] = useState({
    type: "freetrail_report",
    search_key: "",
    status: "",
    page: 1,
    per_page: 10,
    testing_account_filter: "hide",
  });

  const userList = useSelector((state) => state?.reusableSlice?.userList);
  const membershipList = useSelector(
    (state) => state?.reusableSlice?.membershipList
  );

  const invoiceOptions = [
    {
      value: 1,
      label: "Active",
    },
    {
      value: 2,
      label: "Expired",
    },
  ];
  const proOptions = userList?.users?.map((item) => ({
    value: item?.id,
    label: item?.company_name,
  }));

  const proMembOptions = membershipList?.memberships?.map((item) => ({
    value: item?.id,
    label: item?.title,
  }));

  useEffect(() => {
    dispatch(getUserList({ search_key: "" }));
    dispatch(getMembershipList({ search_key: "" }));
  }, [dispatch, params]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      user_id: "",
      start_date: "",
      end_date: "",
      status: "",
      testing_account_filter: "hide",
      type: "freetrail_report",
    },
    validationSchema: invoiceReportValidation,
    onSubmit: (values) => {
      if (
        values.user_id ||
        values.status ||
        values.start_date ||
        values.end_date ||
        values.testing_account_filter !== "hide"
      ) {
        handleSubmit(values);
      }
      return;
    },
  });

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    formik.setFieldValue("user_id", selected?.value);
  };

  const handleStartDateChange = (event) => {
    setStartDates(event.target.value);
    formik.setFieldValue("start_date", event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDates(event.target.value);
    formik.setFieldValue("end_date", event.target.value);
  };

  const handleSelectStatus = (stat) => {
    setSlectStatus(stat.values);
    formik.setFieldValue("status", stat.value);
  };

  const handleGetReports = (data) => {
    getAllReports(data)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          setLoading(false);
          if (res.data.response) {
            setReportsData(res.data.response);
          } else {
            setReportsData([]);
          }
        }
      })
      .catch((e) => {
        console.log(e, "error in get report");
        setIsLoading(false);
        setLoading(false);
      });
  };

  function extractDate(dateString) {
    return formatDateInput(dateString);
  }

  const handleExportReport = () => {
   setExportLoader(true);
    exportAllReports(theFilterInfo)
      .then((response) => {
        if (response.data) {
             setExportLoader(false);
          const header = [
            [
              "sl",
              "Company Name",
              "Membership Plan",
              "Simplified Total",
              "Simplified Left",
              "VAT Total",
              "VAT Left",
              "Purchase Total",
              "Purchase Left",
              "Start Date",
              "End Date",
              "Status",
            ],
          ];

          const data = response.data.freetrail_report.map((prop, index) => [
            index + 1,
            prop.company_name,
            prop.duration_type === 1
              ? "Month"
              : prop.duration_type === 2
              ? "Annually"
              : "Days",
            prop.max_invoices == "10000" ? "Unlimited" : prop?.max_invoices,
            prop.invoice_left == "10000" ? "Unlimited" : prop?.invoice_left,
            prop.max_invoices1 == "10000" ? "Unlimited" : prop?.max_invoices1,
            prop.invoice_left1 == "10000" ? "Unlimited" : prop?.invoice_left1,
            prop.max_invoices2 == "10000" ? "Unlimited" : prop?.max_invoices2,
            prop.invoice_left2 == "10000" ? "Unlimited" : prop?.invoice_left2,
            extractDate(prop.start_date),
            extractDate(prop.end_date),
            prop.status === 1 ? "Active" : "Expired",
          ]);

          const worksheet = XLSX.utils.aoa_to_sheet(header); // Add headers
          XLSX.utils.sheet_add_aoa(worksheet, data, { origin: "A2" }); // Add data starting from row 2

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          XLSX.writeFile(workbook, "FreetrialReports.xlsx");
        }
      })
      .catch((e) => {console.log(e, "while exporting reports");  setExportLoader(false);});
  };

  useEffect(() => {
    setIsLoading(true);
    handleGetReports(params);
  }, [params]);

  const handleSubmit = async (values) => {
    setLoading(true);
    const data = {
      ...values,
      page: 1,
      per_page: 10,
    };
    setParams((preval) => ({
      ...preval,
      page: 1,
      ...values,
    }));
    setTheFilterInfo(values);
    handleGetReports(data);
  };

  const handleClearFilter = () => {
    if (
      formik.values.user_id ||
      formik.values.status ||
      formik.values.start_date ||
      formik.values.end_date ||
      formik.values.testing_account_filter !== "hide"
    ) {
      setSelectedOptions("");
      setSlectStatus("");
      setStartDates("");
      setEndDates("");
      setSelectedOptionsMember("");
      setIsLoading(true);
      formik.resetForm();
      setTheFilterInfo({
        user_id: "",
        start_date: "",
        end_date: "",
        status: "",
        testing_account_filter: "hide",
        type: "freetrail_report",
      });
      setParams(() => ({
        type: "freetrail_report",
        search_key: "",
        status: "",
        page: 1,
        per_page: 10,
        testing_account_filter: "hide",
      }));
      handleGetReports({
        user_id: "",
        start_date: "",
        end_date: "",
        membership_id: "",
        status: "",
        per_page: 10,
        testing_account_filter: "hide",
        type: "freetrail_report",
      });
    }
    return;
  };

  return (
    <Card className="">
      <div className="p-3">
        <div className="category-wrapper">
          {/* <h3 className="pb-5">Free Trial Reports</h3> */}
          <div className=" d-flex justify-content-between align-items-center w-100 mb-3">
            <h4>Free Trial Report</h4>
            <div className="d-flex justify-content-between align-items-center ">
              <button
                type="button"
                className="submit-btn  filter-btn mx-5"
                onClick={() => setSHowFilter(!showFilter)}
              >
                <span>
                  <i className="fa-solid fa-filter"></i>{" "}
                  {showFilter ? "Hide Filter" : "Filter"}
                </span>
              </button>
              <button
                type="button"
                className="submit-btn"
                onClick={() => handleExportReport()}
                style={{ width: "max-content" }}
              >
                 {exportLoader ? <Spinner /> : "Export"}
              </button>
            </div>
          </div>
          {showFilter && (
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-md-3 form-group">
                  <label>Select Company</label>
                  <ReactSelect
                    isClearable
                    value={selectedOptions}
                    onChange={handleChange}
                    options={proOptions}
                    placeholder="Select Company"
                  />
                </div>

                <div className="col-md-3 form-group">
                  <label>Select Status</label>
                  <ReactSelect
                    name="status"
                    id="status"
                    value={selectStatus}
                    onChange={handleSelectStatus}
                    options={invoiceOptions}
                    placeholder="select status"
                  />
                </div>

                <div className="col-md-3 form-group">
                  <label>Start Date</label>
                  <input
                    type="date"
                    className="form-control w-100"
                    placeholder="Enter start date"
                    value={startDates}
                    onChange={handleStartDateChange}
                    onBlur={formik.handleBlur}
                    name="start_date"
                  />
                  {formik.touched.start_date && formik.errors.start_date ? (
                    <div className="error">{formik.errors.start_date}</div>
                  ) : null}
                </div>

                <div className="col-md-3 form-group">
                  <label>End Date</label>
                  <input
                    type="date"
                    className="form-control w-100"
                    placeholder="Enter end date"
                    value={endDates}
                    onChange={handleEndDateChange}
                    onBlur={formik.handleBlur}
                    min={startDates || undefined}
                    name="end_date"
                  />
                  {formik.touched.end_date && formik.errors.end_date ? (
                    <div className="error">{formik.errors.end_date}</div>
                  ) : null}
                </div>
                <TestingAccountFilter
                  value={formik.values.testing_account_filter}
                  onChange={formik.handleChange}
                />
              </div>

              <div
                className="d-flex align-items-center justify-content-center mt-3  "
                style={{ columnGap: "20px" }}
              >
                <button
                  className="submit-btn   "
                  style={{ width: "max-content" }}
                  type="submit"
                >
                  {!loading ? "Submit" : <Spinner />}
                </button>
                <button
                  type="button"
                  className="submit-btn  "
                  onClick={() => handleClearFilter()}
                  style={{ width: "max-content" }}
                >
                  Clear
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
      {isLoading ? (
        <FullScreenLoader />
      ) : (
        <CardBody className="table-sec px-3">
          <table className="table border-table-sec">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Company</th>
                <th>Duration Type</th>
                <th scope="col" colSpan="2" className="text-center">
                  Simplified
                </th>
                <th scope="col" colSpan="2" className="text-center">
                  VAT
                </th>
                <th scope="col" colSpan="2" className="text-center">
                  Purchase
                </th>
                <th scope="col">Start Date</th>
                <th scope="col">End Date</th>
                <th>Status</th>
              </tr>
              <tr>
                <th colSpan="3"></th>
                <th>Total</th>
                <th>Left</th>
                <th>Total</th>
                <th>Left</th>
                <th>Total</th>
                <th>Left</th>
                <th colSpan="3"></th>
              </tr>
            </thead>
            <tbody>
              {reportsData &&
              Array.isArray(reportsData.freetrail_report) &&
              reportsData.freetrail_report.length > 0 ? (
                reportsData.freetrail_report.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1 + (params?.page - 1) * 10}</td>
                    <td>{item.company_name}</td>
                    <td>
                      {item.duration_type === 1
                        ? "Month"
                        : item.duration_type === 2
                        ? "Annually"
                        : "Days"}
                    </td>
                    <td>
                      {item?.max_invoices == "10000"
                        ? "Unlimited"
                        : item?.max_invoices}
                    </td>
                    <td>
                      {item?.invoice_left == "10000"
                        ? "Unlimited"
                        : item?.invoice_left}
                    </td>
                    <td>
                      {item?.max_invoices1 == "10000"
                        ? "Unlimited"
                        : item?.max_invoices1}
                    </td>
                    <td>
                      {item?.invoice_left1 == "10000"
                        ? "Unlimited"
                        : item?.invoice_left1}
                    </td>
                    <td>
                      {item?.max_invoices2 == "10000"
                        ? "Unlimited"
                        : item?.max_invoices2}
                    </td>
                    <td>
                      {item?.invoice_left2 == "10000"
                        ? "Unlimited"
                        : item?.invoice_left2}
                    </td>

                    <td>
                      {formatDate(item?.start_date)}
                    </td>
                    <td>
                      {formatDate(item?.end_date)}
                    </td>
                    <td style={{ color: item.status === 1 ? "green" : "red" }}>
                      {item.status === 1 ? "Active" : "Expired"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">
                    Free Trial Reports are Not Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </CardBody>
      )}
      <CommonPagination
        params={params}
        setParams={setParams}
        pagination_meta={reportsData && reportsData?.pagination_meta}
      />
    </Card>
  );
};

export default FreeTrailReport;
